import { Navigate, useLocation } from 'react-router-dom';

// Client texting moved into the Sigil page ("Client texts" view). This
// redirect keeps old /messages?thread= deep-links (pushes, bookmarks) alive.
const Messages = () => {
  const { search } = useLocation();
  return <Navigate to={`/sigil${search}`} replace />;
};

export default Messages;
